import React from "react";
import { useDataProvider } from "react-admin";
import { useDebouncedCallback } from "use-debounce";

export const useAsyncColumnsStorage = (reference) => {
	const dataProvider = useDataProvider();
	const columns = React.useRef(undefined);
	const [isLoaded, setIsLoaded] = React.useState(false);
	const getColumns = () => {
		dataProvider
			.getOne("user-data", {
				id: reference,
			})
			.then(({ data }) => {
				columns.current = data.data;
				setIsLoaded(true);
			});
	};

	React.useEffect(() => {
		getColumns();
	}, [dataProvider, reference]);

	const updateDatabase = useDebouncedCallback((data) => {
		dataProvider
			.update("user-data", {
				id: reference,
				data: { data },
			})
			.then(({ data }) => {
				columns.current = data.data;
			});
	}, 3000);

	return React.useMemo(
		() => ({
			isLoaded: isLoaded,
			get(resource) {
				return columns.current;
			},
			set(resource, data) {
				updateDatabase(data);
			},
		}),
		[isLoaded, columns, updateDatabase]
	);
};
